(() => {
  'use-strict';

  function init(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('initSearchFilters' in element.dataset) {
        return;
      }
      element.dataset.initSearchFilters = true;

      const trigger = element.querySelector('.js-accordion-trigger');
      const focusableChildrens = element.querySelectorAll('a, input, button');
      const filters = element.closest('.js-filters');
      let resum = filters.querySelector('.Filters-resum');
      const submitButton = element
        .closest('.Filters-form')
        .querySelector('.js-form-submit');

      submitButton.addEventListener('mousedown', () => {
        localStorage.setItem('submissionMethod', 'mouse');
      });

      submitButton.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.keyCode === 13) {
          localStorage.setItem('submissionMethod', 'keyboard');
          localStorage.setItem('focusAfterSubmit', 'js-result-filter');
        }
      });

      if (resum === null) {
        resum = document.createElement('div');
        resum.classList.add('Filters-resum', 'Tags');
        filters.append(resum);
      }

      const getNbInputsChecked = () => {
        const checkedInputs = element.querySelectorAll(
          'input[type=checkbox]:checked',
        );
        trigger.dataset.count = checkedInputs.length;
      };

      const getAllInputsChecked = () => {
        const checkedInputs = filters.querySelectorAll(
          'input[type=checkbox]:checked',
        );

        while (resum.firstChild) {
          resum.removeChild(resum.firstChild);
        }

        checkedInputs.forEach((checkbox) => {
          const label = checkbox.nextElementSibling.innerText;
          const clearButton = document.createElement('label');

          clearButton.setAttribute('for', checkbox.getAttribute('id'));
          clearButton.classList.add(
            'Tag',
            'Filters-resumTag',
            '-secondary',
            '-focusable',
            '-alt',
          );
          clearButton.setAttribute('role', 'button');
          clearButton.setAttribute('tabindex', '0');
          clearButton.setAttribute(
            'aria-label',
            `${label} : ${Drupal.t('Clear filter')}`,
          );
          clearButton.innerHTML = `<span>${label}</span>`;
          resum.append(clearButton);

          const selectKeyDown = (event) => {
            if (event.keyCode === 32) {
              // space bar
              event.stopPropagation();
              event.preventDefault();
              checkbox.checked = false;
              getNbInputsChecked();
              getAllInputsChecked();
              document.removeEventListener('keydown', selectKeyDown);
            }
          };

          clearButton.addEventListener('focus', () => {
            document.addEventListener('keydown', selectKeyDown);
          });

          clearButton.addEventListener('blur', () => {
            document.removeEventListener('keydown', selectKeyDown);
          });

          clearButton.addEventListener('click', () => {
            checkbox.checked = false;
            submitButton.click();
          });
        });

        if (checkedInputs.length) {
          const resetButton = document.createElement('button');
          resetButton.setAttribute('type', 'button');
          resetButton.innerHTML = `${Drupal.t('Reset all filters')}`;
          resetButton.classList.add('LinkSimple', 'Filters-reset');
          resum.append(resetButton);
          resetButton.addEventListener('click', () => {
            checkedInputs.forEach((checkbox) => {
              checkbox.checked = false;
            });
            submitButton.click();
          });
        }
      };

      const escapeKeyDown = (event) => {
        if (event.keyCode === 27) {
          // escape
          element.accordion.toggle(false, false);
        }
      };

      const clickOutsideHandle = (event) => {
        let targetEl = event.target; // clicked element
        do {
          if (targetEl === element.parentNode) {
            // This is a click inside, does nothing, just return.
            return;
          }
          // Go up the DOM
          targetEl = targetEl.parentNode;
        } while (targetEl);
        // This is a click outside.
        // eslint-disable-next-line no-use-before-define
        element.accordion.toggle(false, false);
      };
      const blurHandle = (event) => {
        const parentMenuItem = event.target.closest('.js-form-details-filters');
        if (
          event.relatedTarget !== null &&
          parentMenuItem !==
            event.relatedTarget.closest('.js-form-details-filters')
        ) {
          element.accordion.toggle(false, false);
        }
        event.target.blurListenerAttached = false;
        event.target.removeEventListener('blur', blurHandle);
      };
      const focusHandle = (event) => {
        if (!event.target.blurListenerAttached) {
          event.target.blurListenerAttached = true;
          event.target.addEventListener('blur', blurHandle);
        }
      };

      element.addEventListener('accordionOpen', () => {
        // listen to custom accordion event
        document.addEventListener('click', clickOutsideHandle);
        document.addEventListener('keydown', escapeKeyDown);
        element.querySelector('.Filters-selectPanel').classList.add('-active');
      });

      element.addEventListener('accordionClose', () => {
        // listen to custom accordion event
        document.removeEventListener('click', clickOutsideHandle);
        document.removeEventListener('keydown', escapeKeyDown);
        trigger.blur();
        element
          .querySelector('.Filters-selectPanel')
          .classList.remove('-active');
      });

      focusableChildrens.forEach((focusableChildren) => {
        focusableChildren.addEventListener('focus', focusHandle);
        if (focusableChildren.matches('input[type=checkbox]')) {
          focusableChildren.addEventListener('change', () => {
            getNbInputsChecked();
            getAllInputsChecked();
          });
        }
      });
      getNbInputsChecked();
      getAllInputsChecked();
    });
  }

  Drupal.behaviors.searchFilters = {
    attach: () => {
      const elements = document.querySelectorAll('.js-form-details-filters');
      if (elements.length !== 0) {
        init(elements);
      }

      const focusTarget = localStorage.getItem('focusAfterSubmit');
      const submissionMethod = localStorage.getItem('submissionMethod');

      if (focusTarget && submissionMethod === 'keyboard') {
        const elementToFocus = document.querySelector('.' + focusTarget);

        if (elementToFocus) {
          elementToFocus.focus();
        }
        localStorage.removeItem('focusAfterSubmit');
        localStorage.removeItem('submissionMethod');
      }
    },
  };
})();
